import * as colors from './colors'

const style = {
    analyzeFramework: {
        border: '1px solid lightgray',
    },

    container: {
        overflow: 'visible',
        marginTop: '10px',
    },

    frameContainer: {
        fontFamily: 'Roboto Condensed',
        position: 'absolute',
        top: 0,
        textAlign: 'center',
        zIndex: 100,
        gridColumnStart: 'main',
        gridColumnEnd: 'toolbar',
        gridRowStart: 'subheader',
        gridRowEnd: 'bottom',
        pointerEvents: 'none',
        width: '100%',
    },

    frameName: {
        backgroundColor: colors.labelBackgroundColor,
        display: 'inline-block',
        fontFamily: 'Roboto Condensed',
        margin: '2px',
        padding: '4px',
    },

    hasRasters: {
        fontStyle: 'italic',
        fontWeight: 'bolder',
    },

    hasTemporal: {
        color: 'orange',
        fontStyle: 'italic',
        fontWeight: 'bolder',
    },

    hasTransim: {
        color: 'blue',
        fontStyle: 'italic',
        fontWeight: 'bolder',
    },

    help: {
        backgroundColor: 'rgba(0,0,0,0.03)',
        fontSize: 'smaller',
        padding: '5px',
    },

    helpIcon: {
        color: '#999999',
    },

    initial: {
        fontWeight: 'initial',
        fontStyle: 'initial',
        color: 'initial',
    },

    isproject: {
        fontWeight: 'bold',
    },

    mapToolbar: {
        alignItems: 'stretch',
        backgroundColor: 'white',
        boxShadow: '-2px 0 1px -1px rgba(0,0,0,0.2)',
        display: 'flex',
        flexDirection: 'column',
        gridColumnStart: 'toolbar',
        gridColumnEnd: 'right',
        gridRowStart: 'subHeader',
        gridRowEnd: 'bottom',
    },

    mapToolbarTop: {
        flexGrow: '1',
    },

    metaError: {
        textDecoration: 'u1nderline',
        color: 'red',
    },

    mapToolbarBottom: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
    },

    nodeHeader: {
        bottom: '3px',
        color: colors.white,
        direction: 'rtl',
        display: 'inline-block',
        gridColumnStart: 'main',
        gridColumnEnd: 'toolbar',
        gridRowStart: 'top',
        gridRowEnd: 'subHeader',
        left: '-4px',
        overflow: 'hidden',
        position: 'absolute',
        textAlign: 'center',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
    },

    search: {
        textDecoration: 'underline',
        color: 'green',
    },

    titleBarCtr: {
        alignItems: 'center',
        display: 'flex',
    },

    toolbuttonPanel: {
        marginLeft: '28px',
        marginTop: '10px',
        textAlign: 'left',
    },

    toolbutton: {
        border: 'none',
        borderWidth: '2px',
        color: colors.textColor,
        marginRight: '4px',
        paddingBottom: '4px',
        paddingTop: '4px',
    },

    treeRootEntry: {
        paddingBottom: '15px',
    },

    treeLeafEntry: {
        color: 'black',
        marginTop: '2px',
        /* fontSize: '16px', */
    },

    treeFrameworkTitle: {
        direction: 'rtl',
        // display: 'inline-block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap',
    },

    treeFrameworkTitleContainer: {
        paddingRight: '2px',
        paddingBottom: '1px',
    },
}

export default style
